/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component, ElementRef,AfterViewInit } from '@angular/core';
import { LayoutBaseComponent } from '../layout-base.component';

@Component({
  selector: 'information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.less']
})
export class InformationComponent extends LayoutBaseComponent implements AfterViewInit{
       
      constructor( private elRef:ElementRef) { super(); 
                   this.textClass = "ontario-info";
      }

      public get inputClass():string {
             return "ontario-info-icon icon-center " + this.input_class;
      }

      public get labelClass():string {
            return this.label_class;
      }

      public get className():string {
             return "information "+this.class_name;
      }


      public ngAfterViewInit() {
             let myDiv = this.elRef.nativeElement.querySelector('.information');
             super.layoutFromViewInit(myDiv);
      }
}
